/**
 * core/IndexedPngDB
 *
 * A subclass of PngDBReader, this indexed extension provides
 * methods for indexing records by color.
 */

import path from 'path';
import { PngDBReader } from '../../lib/png-db';

import { noop, rgbToVal } from './utils';


export default class IndexedPngDB extends PngDBReader {

    constructor({ name, fields = {}, basePath = '/' }) {
        super();

        this.name = name;
        this.basePath = path.join(basePath, 'db');
        this._userFields = fields.all;

        this.images = fields.all.reduce((a,f) => (a[f] = { url: path.join(this.basePath, `${f}.png`) }) && a, {});
    }


    addRecordsByIndexColor(records, start, stop) {
        const startIdx = rgbToVal(start);
        const stopIdx = rgbToVal(stop);

        [].push.apply(records, this.recordsByIndex(startIdx, stopIdx));
    }


    async loadDataFiles(callback = noop) {
        await this.load(path.join(this.basePath, this.name));

        await Promise.all(this._userFields.map(async fieldName => {
            await this.loadField(fieldName);
            console.info('Loaded: ' + fieldName);
        }));

        await this.loadImages();

        callback();
    }


    loadImages() {
        return new Promise(resolve => {
            let tasks = 0;
            Object.keys(this.images).forEach((k) => {
                tasks++;

                const imageData = this.images[k];
                const image = new Image();

                image.onload = function () {
                    imageData.image = image;

                    if (--tasks === 0) {
                        resolve();
                    }
                };

                image.src = imageData.url;
            });
        });
    }


    recordsByIndex(start, stop) {
        const ans = [];

        for (let i = start; i <= stop; i++) {
            if (!this.records[i]) {
                console.warn('Missing record: ' + i);
                continue;
            }
            ans.push(this.records[i]);
        }

        return ans;
    }


}
